import { render, staticRenderFns } from "./KwicResultWithHeader.vue?vue&type=template&id=ae20d1ee&"
import script from "./KwicResultWithHeader.vue?vue&type=script&lang=js&"
export * from "./KwicResultWithHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.8.3_css-loader@3.6.0_lodash@4.17.21_webpack@4.46.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports